module.exports = __webpack_public_path__ + "static/media/158.fb061286.jpg";